import { LeftAlignIcon, TopAlignIcon } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  justifyContent?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
}

export const JustifyFlexStart = ({ justifyContent, flexDirection, toggleValues }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-justify"
      id="justify-flex-start"
      data-cy="toolbox-flex-justify-start"
      onClick={() =>
        toggleValues({
          justifyContent: 'flex-start',
        })
      }
      isActive={justifyContent === 'flex-start'}
      icon={flexDirection === 'row' ? LeftAlignIcon : TopAlignIcon}
      tooltip="Start"
      color="light"
    />
  );
};
